export function xlstToHtml({
  xml,
  xslTemplate
}: {
  xml: string;
  xslTemplate: string;
}): Promise<string> {
  return new Promise((res, rej) => {
    const xmlHTTPRequest = new XMLHttpRequest();
    xmlHTTPRequest.open("GET", xslTemplate, true);

    xmlHTTPRequest.addEventListener("abort", () => rej());
    xmlHTTPRequest.addEventListener("error", () => rej());

    xmlHTTPRequest.addEventListener("load", async () => {
      try {
        const xsltProcessor = new XSLTProcessor();
        const xslStylesheet = xmlHTTPRequest.responseXML;

        if (xslStylesheet) {
          xsltProcessor.importStylesheet(xslStylesheet);
        } else {
          rej();
        }

        const xmlDoc = new window.DOMParser().parseFromString(xml, "text/xml");
        if (!xmlDoc) {
          rej();
        }

        const htmlElement = xsltProcessor.transformToFragment(xmlDoc, document);
        if (!htmlElement) {
          rej();
        }

        const div = document.createElement("div");

        div.appendChild(htmlElement);

        res(div.innerHTML);
      } catch (ex) {
        rej(ex);
      }
    });

    xmlHTTPRequest.send(null);
  });
}
